"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPodcastPreviewProperty = exports.podcastPreviewPropertyDefinition = void 0;
exports.podcastPreviewPropertyDefinition = {
    view: { label: 'Podcast preview' },
    constraints: [
        {
            name: 'stencils',
            argument: ['podcast-episode'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'podcast-preview',
};
const isPodcastPreviewProperty = (prop) => {
    return prop.name === exports.podcastPreviewPropertyDefinition.name;
};
exports.isPodcastPreviewProperty = isPodcastPreviewProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9kY2FzdC1wcmV2aWV3LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcG9kY2FzdC1wcmV2aWV3LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGlCQUFpQixFQUFFO0lBQ2xDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsaUJBQWlCLENBQUM7U0FDOUI7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsaUJBQWlCO0NBQ1EsQ0FBQTtBQUkxQixNQUFNLHdCQUF3QixHQUFHLENBQUMsSUFBa0IsRUFBa0MsRUFBRTtJQUM3RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssd0NBQWdDLENBQUMsSUFBSSxDQUFBO0FBQzVELENBQUMsQ0FBQTtBQUZZLFFBQUEsd0JBQXdCLDRCQUVwQyJ9